import React from "react";
import ReactTooltip from "react-tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Typography } from "@material-ui/core";
import { Help } from "@material-ui/icons";
import { useStyles } from "./labelStyles";

function FieldLabel(props) {
  const {
    classes: { cursorPointer, question },
    label = null,
    required = true,
    tooltip = null
  } = props;

  return (
    <Box>
      <Typography variant={"h6"} className={question}>
        {label}
        {required && <span className="red">*</span>}
        {tooltip && (
          <Typography
            className={cursorPointer}
            data-tip={tooltip}
            style={{ display: "inline", marginTop: "1vh" }}
          >
            <Help style={{ height: "16px" }} />
          </Typography>
        )}
      </Typography>
      <ReactTooltip html={true} place={'right'} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(FieldLabel);
